import {Basic} from "./Basic";
import {Load} from "./Load";

export class Search
{
    constructor()
    {
        Basic.close_overlay('searchbox');
        this.build_searchbox();
    }

    build_searchbox()
    {
        this.searchboxContainer = Basic.build_overlay('searchbox');

        const inputContainer = document.createElement('form');
        inputContainer.classList.add('w__searchbox--input-container');
        inputContainer.dataset.f = 'search';

        const searchLabel = document.createElement('label'),
              submit = document.createElement('button'),
              submitIcon = new Image();
        searchLabel.classList.add('w__searchbox--label');
        searchLabel.for = 'w--searchbox-search';
        searchLabel.textContent = 'Search for';

        submit.classList.add('w__button');
        submit.classList.add('w__js-button');
        submit.dataset.f = 'do-fulltext-search';
        submit.type = 'submit';
        submitIcon.src = Basic.base + 'pix/icon_search.svg';
        submitIcon.alt = 'Start search';
        submitIcon.classList.add('w__searchbox--icon');
        submit.appendChild(submitIcon);

        this.search = document.createElement('input');
        this.search.classList.add('w__input');
        this.search.classList.add('mod--searchbox');

        this.select = document.createElement('select');
        const options = {
            'everywhere': 0,
            'in Calendar': 41,
            'in News': 17,
            'in Photoblog': 18,
            'in Texts': 34,
            'in Works': 40
        }
        for(const [text, value] of Object.entries(options))
        {
            const option = document.createElement('option');
            option.value = value.toString();
            option.textContent = text;
            this.select.appendChild(option);
        }
        this.select.classList.add('w__input');
        this.select.classList.add('mod--searchbox-select');

        this.outputContainer = document.createElement('div');
        this.outputContainer.classList.add('w__searchbox--output');
        this.outputContainer.innerHTML = sessionStorage.getItem('search');

        inputContainer.appendChild(searchLabel);
        inputContainer.appendChild(this.search);
        inputContainer.appendChild(this.select);
        inputContainer.appendChild(submit);

        this.searchboxContainer.appendChild(inputContainer)
        this.searchboxContainer.appendChild(this.outputContainer);
        this.search.focus();
    }

    get_result()
    {
        const term = this.search.value.trim(),
              tableId = parseInt(this.select.value);

        if(term.length > 1)
        {
            Load.post({
                f: 'search',
                term: term,
                tableId: tableId
            }).then(r => {
                 this.outputContainer.innerHTML = r['html'].toString();
                 sessionStorage.setItem('search',r['html'].toString());
            }).catch(error => {
                console.error(error);
            });
        }
    }
}
